import { render, staticRenderFns } from "./popularityTeam.vue?vue&type=template&id=4ed7c898&scoped=true"
import script from "./popularityTeam.vue?vue&type=script&lang=js"
export * from "./popularityTeam.vue?vue&type=script&lang=js"
import style0 from "./popularityTeam.vue?vue&type=style&index=0&id=4ed7c898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7c898",
  null
  
)

export default component.exports